import type { StreamFilters } from "./types";

/** Everything the Chat page reads for one project. */
export function chatQueryKey(projectId: string) {
  return ["chat", projectId] as const;
}

/** The loaded pages of the stream under one set of filters. */
export function streamQueryKey(projectId: string, f: StreamFilters) {
  return [...chatQueryKey(projectId), "stream", f.q, f.guild, f.player] as const;
}

/** The newest page, polled to count what arrived above the reader. */
export function streamHeadQueryKey(projectId: string, f: StreamFilters) {
  return [...chatQueryKey(projectId), "head", f.q, f.guild, f.player] as const;
}

export function contextQueryKey(
  projectId: string,
  messageId: string,
  before: number,
  after: number,
) {
  return [...chatQueryKey(projectId), "context", messageId, before, after] as const;
}

export function playerSummaryQueryKey(projectId: string, playerId: string) {
  return [...chatQueryKey(projectId), "player", playerId] as const;
}

export function guildOptionsQueryKey(projectId: string) {
  return [...chatQueryKey(projectId), "guilds"] as const;
}
